/**
 * Number of full years since the given date of birth, or null when the date is
 * empty or in the future.
 *
 * Extracted from the patient registration personal-info step (UNIVAPLAT-3748).
 * A 'YYYY-MM-DD' value is read as a local calendar day (not UTC midnight, which
 * shifts the day west of UTC), matching `notFutureDate`. Other string formats are
 * still parsed with `new Date(birthDate)`.
 */
export function calculateAge(birthDate: string): number | null {
    if (!birthDate) return null;

    const today = new Date();
    const isoDay = /^(\d{4})-(\d{2})-(\d{2})$/.exec(birthDate);
    const birth = isoDay
        ? new Date(+isoDay[1], +isoDay[2] - 1, +isoDay[3])
        : new Date(birthDate);
    let age = today.getFullYear() - birth.getFullYear();
    const monthDiff = today.getMonth() - birth.getMonth();

    // Adjust if the birthday has not happened yet this year
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
        age--;
    }

    return age >= 0 ? age : null;
}
